module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/jibunehon_giftcode_01-eb1aabe4377df563c36f53ec67e9a3dc.png";